import React, { useEffect, useState } from 'react';
type Props = {
  initialSeconds?: number;
  variant?: 'light' | 'dark';
};
function pad(n: number) {
  return String(n).padStart(2, '0');
}
export function Countdown({
  initialSeconds = 23 * 3600 + 48 * 60 + 56,
  variant = 'dark'
}: Props) {
  const [remaining, setRemaining] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setRemaining(prev => prev > 0 ? prev - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  const cells = [{
    value: pad(Math.floor(remaining / 3600)),
    label: 'Horas'
  }, {
    value: pad(Math.floor(remaining % 3600 / 60)),
    label: 'Min'
  }, {
    value: pad(remaining % 60),
    label: 'Seg'
  }];
  const isDark = variant === 'dark';
  return <div className="flex items-start justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-296" data-mp="1tcvhakfv2feg">
      {cells.map((cell, i) => <React.Fragment key={cell.label} data-id="element-297" data-mp="34tlqmcfkznca" data-mpi={i}>
          <div className="flex flex-col items-center" data-id="element-298" data-mp="34sk3vap7dceq">
            <div className={`flex h-12 w-12 items-center justify-center rounded-lg font-display text-2xl font-semibold tabular-nums sm:h-20 sm:w-20 sm:rounded-xl sm:text-4xl ${isDark ? 'bg-ink text-cream' : 'bg-white/90 text-ink shadow-sm'}`} data-id="element-299" data-mp="2c7nkge1lqh2l">
              {cell.value}
            </div>
            <span className={`mt-1 text-[8px] uppercase tracking-luxe sm:mt-2 sm:text-[10px] ${isDark ? 'text-cream/70' : 'text-plum/70'}`} data-id="element-300" data-mp="2q653hygkb5e6">
              {cell.label}
            </span>
          </div>
          {i < cells.length - 1 && <span className={`pt-2 font-display text-2xl sm:pt-4 sm:text-4xl ${isDark ? 'text-cream/50' : 'text-plum/40'}`} data-id="element-301" data-mp="1xgodt8kbu2ln">:</span>}
        </React.Fragment>)}
    </div>;
}